import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global error toast for unhandled promise rejections (wallet interactions, etc.)
window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.warn('Unhandled promise:', e && e.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
